module.exports = __webpack_public_path__ + "img/logo_perumin.522a9015.png";